import CryptoIcon from "components/Secondary/CryptoIcon"
import useWindowDimensions from "helpers/screen";
import "../OpenOrdersTable/style.scss"
import "./style.scss"

const mock = {
  name: "BTC-USDC",
  value: 0.3,
  action: "Close"
}

const OpenOrdersAccountsTable = ({}) => {
  const {width} = useWindowDimensions();

  return <div className="openOrdersAccountsTable openOrdersBox openOrdersTable">
        <div className="sorter">
          <p>Name</p>
          <p>SOL Claimable ▼</p>
        </div>

        <div className="openOrdersTable openOrdersAccountsTableMobile">
          {
            [mock,mock,mock,mock,mock,mock,mock,mock,mock,mock].map((item, i) => {
              return <div key={i} className="item">
                <div className="flex">
                  <CryptoIcon symbol="BTC" size={16}/>
                  <p className="tickerName">{item.name}</p>
                </div>
                <div className="status flex">
                  <p>{item.value}</p>
                  <p className="closeButton">{item.action}</p>
                </div>
              </div>
            })
          }
          
        </div>
    </div>
}

export default OpenOrdersAccountsTable;